import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overview-card-layout__title--mobile"
}
const _hoisted_2 = { class: "overview-card-layout__header" }
const _hoisted_3 = {
  key: 0,
  class: "overview-card-layout__footer-actions--left"
}
const _hoisted_4 = {
  key: 1,
  class: "overview-card-layout__footer-actions--right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.title && _ctx.isMobileScreen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_a_card, _mergeProps({ class: "overview-card-layout" }, _ctx.$attrs, { bordered: false }), {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "left-title-element"),
          _renderSlot(_ctx.$slots, "title", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ])
        ])
      ]),
      extra: _withCtx(() => [
        _renderSlot(_ctx.$slots, "extra")
      ]),
      actions: _withCtx(() => [
        (_ctx.$slots['left-actions'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "left-actions")
            ]))
          : _createCommentVNode("", true),
        (_ctx.$slots['right-actions'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "right-actions")
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16)
  ]))
}